<template>
  <div class="flex">
    <span
      class="rounded-full px-2 text-right text-sm text-xs font-normal capitalize"
      :class="badgeClass"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'Load Badge',
  components: {},
  props: {
    text: String,
    color: String,
  },
  computed: {
    badgeClass() {
      switch (this.color) {
        case 'yellow':
          return 'bg-yellow-100 text-yellow-700';
        case 'blue':
          return 'bg-blue-100 text-blue-500';
        case 'light-blue':
          return 'bg-blue-50';
        case 'green':
          return 'bg-green-100 text-green-800';
        case 'red':
          return 'bg-red-200 text-red-500';
        case 'gray':
          return 'bg-gray-100';
        default:
          return 'bg-gray-100';
      }
    },
  },
  setup() {
    return {};
  },
};
</script>
